export const HorizontalFraction = ({
  numerator,
  denominator,
}: {
  numerator: number,
  denominator: number
}) => (
  <span className="HorizontalFraction">
    <span className="HorizontalFraction__numerator">{numerator}</span>
    <span className="HorizontalFraction__divider">/</span>
    <span className="HorizontalFraction__denominator">{denominator}</span>
  </span>
);
